import { useState } from 'react';

const useNightMode = () => {
  const [nightMode, setNightMode] = useState(() => {
    return JSON.parse(localStorage.getItem('nightMode')) || false;
  });

  const updateNightMode = (status) => {
    localStorage.setItem('nightMode', status);
    setNightMode(status);
  };

  return [nightMode, updateNightMode];
};

export default useNightMode;
